<div class="resp-box cursor">
  <span class="icon-green se-icons">action_attach</span>
  <div class="indent-div">
     <div>
       <span translate [translateParams]="{nombre: documents.length}">T_CARD_DOCUMENTS</span>
     </div>
  </div>
</div>
